__turbopack_context__.v({
  "date": "graph-context-message-module-scss-module__dMx8XG__date",
  "dateRow": "graph-context-message-module-scss-module__dMx8XG__dateRow",
  "divider": "graph-context-message-module-scss-module__dMx8XG__divider",
  "dotAirtime": "graph-context-message-module-scss-module__dMx8XG__dotAirtime",
  "dotShare": "graph-context-message-module-scss-module__dMx8XG__dotShare" + " " + "graph-context-message-module-scss-module__dMx8XG__dotAirtime",
  "metricContent": "graph-context-message-module-scss-module__dMx8XG__metricContent",
  "metricLabel": "graph-context-message-module-scss-module__dMx8XG__metricLabel",
  "metricRow": "graph-context-message-module-scss-module__dMx8XG__metricRow",
  "metricValue": "graph-context-message-module-scss-module__dMx8XG__metricValue",
  "metrics": "graph-context-message-module-scss-module__dMx8XG__metrics",
  "root": "graph-context-message-module-scss-module__dMx8XG__root",
});
